import { FC, KeyboardEventHandler, MouseEventHandler, ReactNode } from 'react';
import { styled } from '@mui/material';
import { Box } from '@o2/ui';
import Button from './Button';
import List from './List';

export interface SidebarMenuProps {
  onClick?: MouseEventHandler;
  onKeyDown?: KeyboardEventHandler;
  children?: ReactNode;
  logo?: ReactNode;
}

const StyledBox = styled(Box, {
  name: 'SidebarMenu',
  slot: 'root',
})(({ theme }) => ({
  display: 'flex',
  backgroundColor: theme.palette.background.white,
  flexDirection: 'column',
  gap: theme.spacing(3),
  width: 238,
  boxShadow: '1px 0px 0px rgba(19, 31, 54, 0.15)',
  height: '100%',
  paddingTop: theme.spacing(3),
  [theme.breakpoints.down('lg')]: {
    width: 120,
    gap: theme.spacing(4),
  },
  [theme.breakpoints.down('md')]: {
    width: 276,
    paddingTop: theme.spacing(3),
    gap: theme.spacing(3),
  },
}));

const LogoBox = styled(Box, {
  name: 'SideBarMenu',
  slot: 'logo',
})(({ theme }) => ({
  padding: theme.spacing(0, 4),
}));

type SidebarComponent = FC<SidebarMenuProps> & {
  Button: typeof Button;
  List: typeof List;
};

const SidebarMenu: SidebarComponent = ({ logo, children, ...other }) => {
  return (
    <StyledBox role="presentation" {...other}>
      {logo && <LogoBox>{logo}</LogoBox>}
      {children}
    </StyledBox>
  );
};

SidebarMenu.Button = Button;
SidebarMenu.List = List;

export default SidebarMenu;
